<template>
    <div class="modal fade modalbox" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="margin:auto;max-width:480px;">
                    <h5 class="modal-title">{{ title }}</h5>
                    <a data-dismiss="modal" v-if="btnClose">Tutup</a>
                </div>
                <div class="modal-body" style="overflow: scroll;">
                    <button class="btn btn-text-primary" v-if="loading == true">
                        <div class="spinner-grow text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </button>
                    <slot v-else></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Modal',
    props: {
        title:{
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            required : false,
            default: false
        },
        btnClose: {
            type: Boolean,
            required : false,
            default: true
        }
    },
}
</script>